import Service from '@/services/modules/sync_contracts_and_after_sales.service';

const execute = async({ commit }, _object) => {
    const response = Service.execute(_object);
    return response;
};

export default {
    execute
};